import {Box, Button, IconButton, InputAdornment, TextField} from '@mui/material';
import {Search as SearchIcon, Clear as ClearIcon} from '@mui/icons-material';
import {useSearchParams} from 'react-router-dom';
import {useState, useEffect} from 'react';

export default function Search({placeholder = 'بحث...', searchParam = 'search'}) {
	const [searchParams, setSearchParams] = useSearchParams();
	const [searchValue, setSearchValue] = useState(searchParams.get(searchParam) || '');

	useEffect(() => {
		setSearchValue(searchParams.get(searchParam) || '');
	}, [searchParams, searchParam]);

	const handleSearch = (value) => {
		const params = new URLSearchParams(searchParams);
		if (value) {
			params.set(searchParam, value);
			// Reset to page 1 when searching
			params.set('page', '1');
		} else {
			params.delete(searchParam);
		}
		setSearchParams(params);
	};

	const handleChange = (e) => {
		const value = e.target.value;
		setSearchValue(value);
	};

	const handleKeyPress = (e) => {
		if (e.key === 'Enter') {
			handleSearch(searchValue);
		}
	};

	const handleClear = () => {
		setSearchValue('');
		handleSearch('');
	};

	const handleSubmit = () => {
		handleSearch(searchValue);
	};

	return (
		<Box sx={{display: 'flex', gap: 1, alignItems: 'center'}}>
			<TextField
				size="small"
				placeholder={placeholder}
				value={searchValue}
				onChange={handleChange}
				onKeyPress={handleKeyPress}
				sx={{minWidth: 300}}
				InputProps={{
					startAdornment: (
						<InputAdornment position="start">
							<SearchIcon />
						</InputAdornment>
					),
					endAdornment: searchValue && (
						<InputAdornment position="end">
							<IconButton size="small" onClick={handleClear}>
								<ClearIcon fontSize="small" />
							</IconButton>
						</InputAdornment>
					),
				}}
			/>
			<Button variant="contained" onClick={handleSubmit}>
				بحث
			</Button>
		</Box>
	);
}
